// PREZZI_BOLLE_v1 (+v2: scritte non maiuscole) — dalla fattura XML ai prezzi nelle bolle e, su scelta, al listino
import React, { useState, useEffect } from "react";

const C = {
  bg: "#0f1117", surface: "#1a1d27", surface2: "#21253a", border: "#2a2e45", accent: "#f5a623", accentSoft: "#f5a62322",
  text: "#e8eaf2", muted: "#7b82a0", dim: "#4a5068", ok: "#3ecf8e", err: "#f06060", info: "#4e9af5",
};
function tok() { try { return localStorage.getItem("bertoc_jwt") || ""; } catch (e) { return ""; } }
async function api(url, opts) {
  const o = opts || {};
  const h = { Authorization: "Bearer " + tok() };
  if (o.body) h["Content-Type"] = "application/json";
  const r = await fetch(url, { method: o.method || "GET", headers: h, body: o.body ? JSON.stringify(o.body) : undefined });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || ("Errore " + r.status));
  return j;
}
const eu = (n, dec) => n === null || n === undefined || isNaN(Number(n)) ? "—" : "€ " + Number(n).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: dec || 2 });
const dIt = s => /^\d{4}-\d{2}-\d{2}/.test(s || "") ? s.slice(8, 10) + "/" + s.slice(5, 7) + "/" + s.slice(0, 4) : (s || "");
const btn = primo => ({ padding: "9px 14px", borderRadius: 9, border: "1px solid " + (primo ? C.accent : C.border), background: primo ? C.accent : C.surface, color: primo ? "#1a1d27" : C.text, fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" });
const STATO = {
  senza: ["senza prezzo", C.accent],
  diverso: ["prezzo diverso", C.info],
  uguale: ["✓ già giusto", C.ok],
  quantita: ["quantità da controllare", C.err],
  unitaDiversa: ["unità diverse: a mano", C.muted],
  nonTrovato: ["non trovato in fattura", C.dim],
};

export default function PrezziBolle({ docId, onClose }) {
  const [p, setP] = useState(null);
  const [errore, setErrore] = useState("");
  const [selB, setSelB] = useState({});
  const [selL, setSelL] = useState({});
  const [vediEsclusi, setVediEsclusi] = useState(false);
  const [lavoro, setLavoro] = useState(false);
  const [fatto, setFatto] = useState(null);

  async function carica() {
    try {
      const j = await api("/api/cassetta/documenti/" + docId + "/prezzi-bolle");
      setP(j);
      const b = {};
      j.bolle.forEach(bo => bo.righe.forEach(r => { if (r.stato === "senza") b[bo.bollaId + ":" + r.idx] = true; }));
      setSelB(b);
      const l = {};
      j.listino.forEach(x => { if (x.listinoId && !x.escluso) l[x.n] = true; });
      setSelL(l);
    } catch (e) { setErrore(e.message); }
  }
  useEffect(() => { carica(); }, [docId]);

  async function applica() {
    const bolle = [];
    p.bolle.forEach(bo => bo.righe.forEach(r => { if (selB[bo.bollaId + ":" + r.idx] && r.prezzoNuovo) bolle.push({ bollaId: bo.bollaId, idx: r.idx, prodotto: r.prodotto, prezzo: r.prezzoNuovo }); }));
    const listino = Object.keys(selL).filter(k => selL[k]).map(Number);
    if (!bolle.length && !listino.length) { alert("Non hai scelto niente da aggiornare."); return; }
    if (!window.confirm("Aggiornare " + bolle.length + " righe di bolle e " + listino.length + " prodotti del listino con i prezzi di questa fattura?")) return;
    setLavoro(true);
    try { setFatto(await api("/api/cassetta/documenti/" + docId + "/prezzi-bolle", { method: "POST", body: { bolle, listino } })); await carica(); }
    catch (e) { alert(e.message); }
    setLavoro(false);
  }

  const tutte = p ? p.bolle.flatMap(bo => bo.righe.map(r => ({ ...r, bollaId: bo.bollaId }))) : [];
  const conta = s => tutte.filter(r => r.stato === s).length;
  const nSelB = Object.values(selB).filter(Boolean).length, nSelL = Object.values(selL).filter(Boolean).length;
  const lAgg = p ? p.listino.filter(x => x.listinoId && !x.escluso) : [];
  const lNuovi = p ? p.listino.filter(x => !x.listinoId && !x.escluso) : [];
  const lEscl = p ? p.listino.filter(x => x.escluso) : [];

  const rigaL = x => (
    <label key={x.n} style={{ textTransform: "none", letterSpacing: 0, fontWeight: 400, color: C.text, display: "flex", gap: 8, alignItems: "flex-start", padding: "5px 0", borderTop: "1px solid " + C.border, fontSize: 13, cursor: "pointer" }}>
      <input type="checkbox" checked={!!selL[x.n]} onChange={e => setSelL({ ...selL, [x.n]: e.target.checked })} style={{ marginTop: 3 }} />
      <span style={{ flex: 1, minWidth: 0 }}>{x.desc}{x.codice ? <span style={{ color: C.dim }}> · {x.codice}</span> : null}
        {x.listinoId && x.prodottoListino && x.prodottoListino.toUpperCase() !== x.desc.toUpperCase() ? <div style={{ fontSize: 11, color: C.muted }}>nel listino: {x.prodottoListino}</div> : null}
      </span>
      <span style={{ whiteSpace: "nowrap" }}>{x.listinoId ? <span style={{ color: C.muted }}>{eu(x.prezzoListino, 4)} → </span> : null}<b>{eu(x.netto, 4)}</b><span style={{ color: C.muted }}>/{x.um || "cad"}</span></span>
    </label>
  );

  return (
    <div style={{ position: "fixed", inset: 0, background: "#000a", zIndex: 1000, display: "flex", justifyContent: "center", alignItems: "flex-start", overflowY: "auto", padding: "24px 10px" }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ background: C.surface, border: "1px solid " + C.border, borderRadius: 14, padding: 18, width: "100%", maxWidth: 820, color: C.text }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 10 }}>
          <div>
            <div style={{ fontFamily: "'Syne',sans-serif", fontWeight: 700, fontSize: 18 }}>💶 Prezzi nelle bolle</div>
            {p && <div style={{ fontSize: 13, color: C.muted, marginTop: 2 }}>Fattura {p.documento.fornitore} n. {p.documento.numero} del {dIt(p.documento.data)}</div>}
          </div>
          <button style={{ ...btn(false), padding: "6px 10px" }} onClick={onClose}>✕</button>
        </div>
        {errore && <div style={{ color: C.err, marginTop: 12 }}>⚠️ {errore}</div>}
        {!p && !errore && <div style={{ color: C.muted, marginTop: 12 }}>Confronto la fattura con le bolle…</div>}
        {p && (
          <>
            {fatto && <div style={{ marginTop: 12, padding: 10, borderRadius: 10, border: "1px solid " + C.ok, color: C.ok, fontSize: 14 }}>✓ Aggiornate {fatto.righe} righe in {fatto.bolle} bolle · listino: {fatto.listino} prezzi aggiornati{fatto.nuovi ? ", " + fatto.nuovi + " prodotti nuovi" : ""}</div>}
            {!fatto && p.documento.prezziBolle && <div style={{ marginTop: 12, fontSize: 13, color: C.muted }}>Già fatto il {dIt(String(p.documento.prezziBolle.il || "").slice(0, 10))}: {p.documento.prezziBolle.righe} righe in {p.documento.prezziBolle.bolle} bolle.</div>}
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 12 }}>
              {["senza", "diverso", "quantita", "uguale", "unitaDiversa", "nonTrovato"].filter(s => conta(s)).map(s => (
                <span key={s} style={{ fontSize: 12, padding: "4px 9px", borderRadius: 8, border: "1px solid " + STATO[s][1], color: STATO[s][1] }}>{STATO[s][0]}: {conta(s)}</span>
              ))}
            </div>
            {p.bolle.length === 0 && <div style={{ marginTop: 12, fontSize: 14 }}>Nessuna bolla del gestionale corrisponde ai DDT di questa fattura.</div>}
            {p.ddtSenzaBolla.length > 0 && <div style={{ marginTop: 8, fontSize: 12, color: C.muted }}>DDT della fattura che non sono nel gestionale: {p.ddtSenzaBolla.join(", ")}</div>}

            {p.bolle.map(bo => (
              <div key={bo.bollaId} style={{ marginTop: 14, background: C.surface2, borderRadius: 10, padding: "10px 12px" }}>
                <div style={{ fontWeight: 700, fontSize: 14 }}>Bolla n. {bo.num} del {dIt(bo.data)} <span style={{ color: C.muted, fontWeight: 400 }}>· {Array.from(new Set(bo.righe.map(r => r.cantiere).filter(Boolean))).join(", ")}</span></div>
                {bo.righe.map(r => {
                  const k = bo.bollaId + ":" + r.idx;
                  const scegli = r.stato === "senza" || r.stato === "diverso" || r.stato === "quantita";
                  return (
                    <label key={r.idx} style={{ textTransform: "none", letterSpacing: 0, fontWeight: 400, color: C.text, display: "flex", gap: 8, alignItems: "flex-start", padding: "6px 0", borderTop: "1px solid " + C.border, fontSize: 13, cursor: scegli ? "pointer" : "default", opacity: scegli ? 1 : 0.65 }}>
                      {scegli ? <input type="checkbox" checked={!!selB[k]} onChange={e => setSelB({ ...selB, [k]: e.target.checked })} style={{ marginTop: 3 }} /> : <span style={{ width: 13 }} />}
                      <span style={{ flex: 1, minWidth: 0 }}>
                        {r.prodotto} <span style={{ color: C.muted }}>· {r.qta} {r.um}</span>
                        <div style={{ fontSize: 11, color: STATO[r.stato][1] }}>{STATO[r.stato][0]}{r.rf ? " · in fattura: " + r.rf.qta + " " + r.rf.um + " a " + eu(r.rf.netto, 4) + (r.rf.lordo && Math.abs(r.rf.lordo - r.rf.netto) > 0.005 ? " (scontato da " + eu(r.rf.lordo, 4) + ")" : "") + (r.come && r.come !== "codice" ? " · " + r.come : "") : ""}{r.nota ? " · " + r.nota : ""}</div>
                      </span>
                      <span style={{ whiteSpace: "nowrap", textAlign: "right" }}>
                        {r.prezzoAttuale > 0 ? <span style={{ color: C.muted }}>{eu(r.prezzoAttuale, 4)}{r.prezzoNuovo && r.stato !== "uguale" ? " → " : ""}</span> : null}
                        {r.prezzoNuovo && r.stato !== "uguale" ? <b>{eu(r.prezzoNuovo, 4)}</b> : null}
                        <span style={{ color: C.muted }}>/{r.um || "cad"}</span>
                      </span>
                    </label>
                  );
                })}
              </div>
            ))}
            {conta("diverso") > 0 && (
              <div style={{ fontSize: 12, color: C.muted, marginTop: 8 }}>
                I prezzi diversi di solito sono sconti che prima non erano entrati, o prezzi a sacco su una riga in kg. Non sono spuntati: spunta quelli da correggere, oppure{" "}
                <span style={{ color: C.info, cursor: "pointer", textDecoration: "underline" }} onClick={() => { const b = { ...selB }; p.bolle.forEach(bo => bo.righe.forEach(r => { if (r.stato === "diverso") b[bo.bollaId + ":" + r.idx] = true; })); setSelB(b); }}>spunta tutti i prezzi diversi</span>.
              </div>
            )}
            {conta("quantita") > 0 && <div style={{ fontSize: 12, color: C.err, marginTop: 6 }}>"Quantità da controllare": la bolla dice per esempio 1 kg di un sacco da 25 kg. Probabilmente era 1 sacco: correggi la quantità nella bolla prima di mettere il prezzo.</div>}

            {(lAgg.length > 0 || lNuovi.length > 0) && (
              <div style={{ marginTop: 16 }}>
                <div style={{ fontWeight: 700, fontSize: 15 }}>📋 Listino</div>
                {lAgg.length > 0 && <div style={{ fontSize: 12, color: C.muted, margin: "6px 0 2px" }}>Prodotti già nel listino: si aggiorna il prezzo ({lAgg.length})</div>}
                {lAgg.map(rigaL)}
                {lNuovi.length > 0 && <div style={{ fontSize: 12, color: C.muted, margin: "10px 0 2px" }}>Prodotti nuovi: entrano nel listino solo se li spunti ({lNuovi.length})</div>}
                {lNuovi.map(rigaL)}
                {lEscl.length > 0 && <div onClick={() => setVediEsclusi(!vediEsclusi)} style={{ fontSize: 12, color: C.dim, marginTop: 8, cursor: "pointer" }}>{vediEsclusi ? "▾" : "▸"} Trasporti, servizi e simili, lasciati fuori ({lEscl.length})</div>}
                {vediEsclusi && lEscl.map(rigaL)}
              </div>
            )}

            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 16, alignItems: "center" }}>
              <button style={btn(true)} disabled={lavoro} onClick={applica}>{lavoro ? "Aggiorno…" : "Aggiorna " + nSelB + " righe e " + nSelL + " prodotti"}</button>
              <button style={btn(false)} onClick={onClose}>Chiudi</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
